import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ListContext = /*#__PURE__*/createContext({});

/**
 * @internal
 */
export const useListContext = () => {
  return useContext(ListContext);
};

/**
 * @internal
 */
export const ListContextProvider = props => {
  const [listContext, setListContext] = useState({
    tableHasVerticalScrollbar: false
  });
  const contextValue = {
    setListContext,
    ...listContext
  };
  return /*#__PURE__*/_jsx(ListContext.Provider, {
    value: contextValue,
    children: props.children
  });
};
//# sourceMappingURL=ListContext.js.map